import cryptoJs from 'crypto-js'
import { Message } from 'element-ui';
let keyOne = 'pinming@20180821'
// 加密函數
const aesEncrypt = (word, aesSecrect) => {
    if (aesSecrect === undefined || aesSecrect == '') {
        aesSecrect = keyOne
    }
    let key = cryptoJs.enc.Utf8.parse(aesSecrect)
    let enc = ''

    enc = cryptoJs.AES.encrypt(word, key, {
        iv: cryptoJs.enc.Utf8.parse(aesSecrect.substr(0, 16)),
        mode: cryptoJs.mode.CBC,
        padding: cryptoJs.pad.Pkcs7
    })
    let encResult = enc.toString()
    return encResult
}

/**
 * 解密函數
 * @param {*} word
 */
const aesDecrypt = (word, aesSecrect) => {
    if (aesSecrect === undefined || aesSecrect == '') {
        aesSecrect = keyOne
    }
    let key = cryptoJs.enc.Utf8.parse(aesSecrect)
    let dec = cryptoJs.AES.decrypt(word, key, {
        iv: cryptoJs.enc.Utf8.parse(aesSecrect.substr(0, 16)),
        mode: cryptoJs.mode.CBC,
        padding: cryptoJs.pad.Pkcs7
    })
    let decData = cryptoJs.enc.Utf8.stringify(dec)
    return decData
}

//随时数
const randerTimeKey = () => {
    return (new Date()).getTime();
}

//数据解析
const parseSource = (src,args) => {
    try {
        let obj= src?JSON.parse(src):{};
        obj=Object.assign(obj,args);
        return obj;
    }catch (e) {
        Message.error('数据配置错误，无法解析')
        return {}
    }
}

const IEVersion = () => {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
            return 7;
        } else if (fIEVersion == 8) {
            return 8;
        } else if (fIEVersion == 9) {
            return 9;
        } else if (fIEVersion == 10) {
            return 10;
        } else {
            return 6; //IE版本<=7
        }
    } else if (isEdge) {
        return "edge"; //edge
    } else if (isIE11) {
        return 11; //IE11
    } else {
        return -1; //不是ie浏览器
    }
}

//是否IE浏览器
const isIEBrowser = () => {
    let IEV = IEVersion();
    return IEV > -1 ? true : false;
}

export {
    randerTimeKey,
    parseSource,
    aesEncrypt,
    aesDecrypt,
    isIEBrowser,
}
